import { render, staticRenderFns } from "./adjustment.vue?vue&type=template&id=1276c5f6&"
import script from "./adjustment.vue?vue&type=script&lang=js&"
export * from "./adjustment.vue?vue&type=script&lang=js&"
import style0 from "./adjustment.vue?vue&type=style&index=0&id=1276c5f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports